import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
// import TextField from "@material-ui/core/TextField";
import Slider from "@material-ui/core/Slider";
// import clsx from "clsx";
import { arrayView } from "../../../utils/arrays";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(4),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  info: {
    display: "flex",
    alignItems: "center",
    margin: "8px 0px",
    color: "#1a2633",
    width: 200,
    [theme.breakpoints.down("md")]: {
      width: 180,
      paddingLeft: 20,
    },
    [theme.breakpoints.down("sm")]: {
      width: 120,
    },
  },
  infoLine: {
    flex: 1,
    background: "#60768e",
    height: 1,
    fontSize: 0,
    lineHeight: 0,
    margin: "0px 16px",
  },
  body: {
    marginTop: 20,
    marginBottom: 35,
    [theme.breakpoints.down("lg")]: {
      marginBottom: 15,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
      marginBottom: 0,
      paddingRight: 20,
      paddingLeft: 20,
      minHeight: "auto",
    },
  },
  bodybol: {
    marginTop: 12,
    marginBottom: 32,
    [theme.breakpoints.down("lg")]: {
      marginTop: 12,
      marginBottom: 1,
      },
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
      marginBottom: 20,
    },
  },
  inputLine: {
    width: "50%",
    color: "#1a2633",
  },
  buttons: {
    float: "left",
    "& > .on": {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    "& > div": {
      display: "inline-block",
      backgroundColor: "#ffffff",
      fontSize: 18,
      width: 80,
      height: 36,
      marginRight: 16,
      cursor: "pointer",
      textAlign: "center",
      lineHeight: 2.1,
      color: "#b1b1b1",
      borderRadius: 3,
      border: "1px solid #b1b1b1",
    },

    [theme.breakpoints.down("sm")]: {
      paddingTop: 20,
    },
  },
  textField1: {
    width: 142,
    height: 40,
    paddingLeft: 12,
    borderColor: "rgb(133, 133, 133)",
    borderRadius: "5px",
    backgroundSize: "12px 12px",
    background: `url(/images/ex/simple_down_arrow.jpg) no-repeat 93% 50%`,
    backgroundColor: "#ffffff",
    fontSize: 16,
    appearance: "none",
    "&::-ms-expand": {
      display: "none",
    },
  },
  inputView: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      paddingTop: 20,
    },
  },
  inputTitle: {
    width: 120,
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      height: 58,
      fontSize: 18,
    },
  },
  buttonBack: {
    width: 432,
    height: 78,
    fontSize: 20,
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
      height: 58,
      fontSize: 18,
    },
  },
  contents: {
    marginTop: 10,
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: 16,
      alignItems: "flex-start",
    },
  },
  regular: {
    fontSize: 22,
    [theme.breakpoints.down("sm")]: {
      fontSize: 15,
    },
  },  
  maxWidth: {
    [theme.breakpoints.down("md")]: {
      maxWidth: 500,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  bold: {
    fontSize: 24,
    fontWeight: 700,
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },
  txt: {
    width: 36,
    textAlign: "right",
  },
  txtData: {
    fontWeight: 600,
    width: 44,
    textAlign: "right",
  },
  footer: {
    marginTop: 12,
    marginBottom: 36,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  large: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));
const FormList = ({
  score,
  onChange,
  onRangeChange,
  onYearChang,
  inputElGap,
}) => {
  const classes = useStyles();
  const gapArray = arrayView(0, 80);
  return (
    <>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.root}
      >
        <Grid className={classes.info}>
          <Typography variant="h3">병력 및 생활습관</Typography>
        </Grid>
        <Grid className={classes.infoLine}></Grid>
      </Grid>
      <Grid container direction="column" className={classes.body}>
        <Grid
          container
          direction="column"
          justify="center"
          className={classes.bodybol}
        >
          <Typography variant="h4">
            <span className={classes.bold}>당뇨</span>
          </Typography>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            className={classes.contents}
          >
            <Grid className={classes.maxWidth}>
              <Typography variant="h4">
                <span className={classes.regular}>
                  당뇨를 진단받은 적이 있습니까?
                </span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("dmyn", true)}
                  className={`${score.dmyn ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("dmyn", false)}
                  className={`${!score.dmyn ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          className={classes.bodybol}
        >
          <Typography variant="h4">
            <span className={classes.bold}>고혈압</span>
          </Typography>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            className={classes.contents}
          >
            <Grid className={classes.maxWidth}>
              <Typography variant="h4">
                <span className={classes.regular}>
                  평소 혈압이 수축기 140mmHg 이상, 이완기 90mmHg이상이거나 현재
                  고혈압 약을 복용 중이신가요?
                </span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("hpyn", true)}
                  className={`${score.hpyn ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("hpyn", false)}
                  className={`${!score.hpyn ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>규칙적 운동</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid className={classes.maxWidth}>
              <Typography variant="h4">
                <span className={classes.regular}>
                  규칙적인 운동(하루 20분 이상 격렬한 운동을 주 3회 또는 하루
                  30분이상 중등도 운동 주 5회 이상) 을 하시나요?
                </span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("pa", true)}
                  className={`${score.pa ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("pa", false)}
                  className={`${!score.pa ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          className={classes.bodybol}
          container
          justify="space-between"
          alignItems="center"
        >
          <Typography variant="h4">
            <span className={classes.bold}>흡연</span>
          </Typography>
          <Grid
            className={classes.contents}
            container
            alignItems="center"
            justify="space-between"
          >
            <Grid>
              <Typography variant="h4">
                <span className={classes.regular}>흡연을 해보셨나요?</span>
              </Typography>
            </Grid>
            <Grid>
              <Grid className={classes.buttons}>
                <Grid
                  onClick={() => onChange("smoking", true)}
                  className={`${score.smoking ? "on" : "off"}`}
                >
                  예
                </Grid>
                <Grid
                  onClick={() => onChange("smoking", false)}
                  className={`${!score.smoking ? "on" : "off"}`}
                >
                  아니오
                </Grid>
              </Grid>
            </Grid>
            {score.smoking && (
              <>
                <Grid
                  className={classes.contents}
                  container
                  alignItems="center"
                  justify="space-between"
                >
                  <Grid>
                    <Typography variant="h4">
                      <span className={classes.regular}>
                        흡연을 해보셨다면 몇 년 동안 흡연하셨나요?
                      </span>
                    </Typography>
                  </Grid>
                  <Grid>
                    <Grid
                      container
                      justify="flex-end"
                      className={classes.inputView}
                      style={{ paddingRight: 16 }}
                    >
                      {/* <TextField
                        type="number"
                        disabled={!score.smoking}
                        inputRef={inputElGap}
                        value={score.gapYear}
                        onChange={(e) => onYearChang("gapYear", e)}
                        inputProps={{
                          type: "number",
                          min: "0",
                          step: "1",
                        }}
                        className={classes.textField1}
                        variant="outlined"
                        size="small"
                      /> */}
                      <select
                        className={classes.textField1}
                        value={score.gapYear}
                        onChange={(e) => onYearChang("gapYear", e)}
                        ref={inputElGap}
                      >
                        {gapArray.map((num, index) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        ))}
                      </select>
                      <Grid className={classes.txt}>년</Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="space-between"
                  className={classes.contents}
                >
                  <Grid>
                    <Typography variant="h4">
                      <span className={classes.regular}>
                        하루에 평균 몇 갑을 피우셨나요?
                      </span>
                    </Typography>
                  </Grid>
                  <Grid>
                    <Grid
                      container
                      className={classes.inputView}
                      justify="flex-end"
                      style={{ paddingRight: 16 }}
                    >
                      <Grid style={{ width: 120 }}>
                        <Slider
                          value={score.smokingGap}
                          onChange={(e, val) => onRangeChange(e, val)}
                          min={0}
                          max={5}
                          step={0.5}
                          aria-label="Default"
                          valueLabelDisplay="auto"
                        />
                      </Grid>
                      <Grid className={classes.txtData}>
                        {score.smokingGap}
                      </Grid>
                      <Grid className={classes.txt}>갑</Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default FormList;
